"use strict";

/**
 * @type Controller
 * @name trialMessageCtrl
 * @packageName trialMessage_ctrl.js
 */
class TrialMessageCtrl {


    constructor($http, $cookies, $location, $rootScope, $state, $transitions) {
        this.$cookies = $cookies;
        this.$http = $http;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$transitions = $transitions;
        this.endTrial = {};
        this.organisationUser = true;

        this.disabledStates = [
            'rundown',
            'contacts',
            'template',
            'campaign'
        ];

        this.checkTrial();
    }

    closeWarning(leaveAlone) {
        this.warnElement.fadeOut(250);
        angular.element('.pb-warn-countdown-container .text').animate({
            'top': '+=25%'
        }, 250);
        if (leaveAlone) {
            let expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 5);
            this.$cookies.put('trialUnderstood', true, {'expires': expireDate});
        }
    }

    addWarning() {
        setTimeout(() => {
            this.warnElement.fadeIn(350);
        });
    }

    toSubscription() {
        this.$state.go('buynow');
        this.closeWarning(false);
    }

    getDayEnds(endtrial) {
        let endTrial = new moment(endtrial);
        let now = moment();
        this.endTrial.string = endTrial.fromNow();
        this.endTrial.days = endTrial.diff(now, 'days');

        let trialData = {
            translation: 'messages.trial_ends_in',
            object: this.endTrial.string
        };

        console.log(this.endTrial);

        this.$http.post('/translateobject', trialData).then((res) => {
            this.trialTranslation = res.data;
        });
    }

    trialEnded() {
        let unReg = this.$rootScope.$on('$viewContentLoaded', () => {
            if(this.disabledStates.indexOf(this.$state.current.name) > -1){
                this.$state.go('trialended');
            }

            unReg();
        });

        this.$transitions.onStart({ }, (transition) => {
            let toState = transition.to();
            if(this.disabledStates.indexOf(toState.name) > -1){
                transition.abort();
                this.$state.go('trialended');
            }
        });
    };

    checkTrial() {
        this.$http.get('/station').then((response) => {
            let data = response.data;
            if (data.trial_date != '0000-00-00') {
                this.getDayEnds(data.trial_date);

                if (this.$cookies.get('trialUnderstood') === undefined) {
                    if (response.data.user === null) {
                        this.organisationUser = false;
                    }
                    this.warnElement = angular.element('.pb-warn-countdown-container');
                    this.addWarning();
                }

                if (this.endTrial.days < 0) {
                    this.trialEnded();
                }
            }
        });
    }

}


/*
 * Inject dependicies
 */
TrialMessageCtrl.$inject = ['$http', '$cookies', '$location', '$rootScope', '$state', '$transitions'];


/*
 * Browsify connection: execute controller
 */
module.exports = TrialMessageCtrl;
